import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/financialSchedulesReportActions'
import * as api from '../../../api/reports/jobs/financialSchedulesReport'

function* financialSchedulesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* financialSchedulesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchfinancialSchedulesReportGetJobList() {
  yield takeLatest(
    constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    financialSchedulesReportGetJobList
  )
}

function* watchfinancialSchedulesReportGetFullReport() {
  yield takeLatest(
    constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    financialSchedulesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchfinancialSchedulesReportGetJobList),
    fork(watchfinancialSchedulesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/financialSchedulesReportSaga.js